import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Drawer, Table, Button, Tooltip } from 'antd';

import ErrorDisplay from '../viewer/errorDisplay';
import { openModal } from '../../actions/modal';
import './replyMessageSidebar.scss';
import { getReferralsQuery } from '../../actions/records';
import { getVisibleSmsTemplatesForCurrentUser } from '../../util/referralTemplateStorage';

class smsMessageSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      resentMessages: false,
    };
  }

  handleResend = async (record) => {
    this.setState({
      resentMessages: true,
    });
    const {
      send_token: sendToken,
      receiver_type: receiverType,
      patient_name: patientName,
      patient_dob: patientDOB,
      referring_provider: referringProvider,
      message,
      to_number,
      slug,
    } = record;

    // Convert receiver_type to snake_case
    const formattedReceiverType = receiverType.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '');

    const messageParts = message.split('\n\n');
    const messageContent = messageParts[0].trim();
    const url = messageParts[1]?.replace('Reply STOP To Opt Out', '').trim();

    if (!patientName || !patientDOB) {
      message.error({
        content: 'Cannot send a message without a valid patient name and date of birth. Edit record details and try again.',
      });
      this.setState({ resentMessages: false });
      return;
    }

    const userTemplates = getVisibleSmsTemplatesForCurrentUser();

    const modalType = {
      type: 'SMS_MESSAGE',
      data: {
        messageTemplates: userTemplates,
        messageText: messageContent,
        patientName,
        referringProvider,
        patientPhoneNumber: to_number,
        receiverType: formattedReceiverType,
        sendToken,
        smsMessageFeature: true,
        shortenedUrl: url,
        resentSlug: slug,
        smsUri: record.sms_uri,
      },
    };
    this.props.openModal(modalType);
  };

  onClose = () => {
    const { location } = this.props;
    if (this.state.resentMessages) {
      this.props.getReferralsQuery(location.search);
      this.setState({ resentMessages: false });
    }
    this.props.toggleSmsSidebar();
  }

  formatDeliveryStatus = (str) => {
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  render() {
    const { error, data } = this.props;
    const {
      sms_messages: smsMessages,
    } = data;

    const hasFailedMessages = smsMessages?.some(message => message.sms_internal_status === 'delivery_failed');

    const columns = [
      {
        title: 'To Number',
        dataIndex: 'to_number',
        key: 'slug',
        width: '20%',
      },
      {
        title: 'Message',
        dataIndex: 'message',
        width: '30%',
      },
      {
        title: 'Status',
        dataIndex: 'sms_internal_status',
        render: (status, record) => {
          if (status === 'delivery_failed') {
            return (
              <Tooltip title={record.sms_error_detail}>
                <span style={{ color: '#ff4d4f' }}>Delivery Failed</span>
              </Tooltip>
            );
          }
          return this.formatDeliveryStatus(status);
        },
      },
      {
        title: 'Transmission Date',
        dataIndex: 'sms_delivered_at',
        width: '20%',
        render: (date) => {
          if (!date) return null;
          const [datePart, ...timeParts] = date.split(' ');
          const timePart = timeParts.join(' ');
          return (
            <>
              <div>{datePart}</div>
              <div>{timePart}</div>
            </>
          );
        },
      },
      ...(hasFailedMessages ? [{
        title: 'Action',
        key: 'action',
        render: (_, record) => (
          record.sms_internal_status === 'delivery_failed' && (
            <Button 
              type="primary" 
              onClick={() => this.handleResend(record)}
            >
              Resend
            </Button>
          )
        ),
      }] : []),
    ];

    return (
      <Drawer
        title="Sms Message(s)"
        placement="right"
        closable={true}
        onClose={this.onClose}
        visible={this.state.visible}
        width={730}
        style={{ marginTop: 60, padding: 0 }}
      >
        <div>
          {error ? <ErrorDisplay sidebar={true} message="Error retrieving reply. Please try again" />
            : (
              <>
                <div style={{ borderTop: '1px solid lightgrey', padding: '25px' }}>
                  <Table 
                    dataSource={smsMessages} 
                    columns={columns} 
                    pagination={{
                      pageSize: 5,
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
                    }}
                    scroll={{ y: 600 }}
                    rowKey="slug"
                  />
                </div>
              </>
            )
          }
        </div>
      </Drawer>
    );
  }
}

smsMessageSidebar.defaultProps = {
  data: {},
  error: false,
};

smsMessageSidebar.propTypes = {
  error: PropTypes.bool,
  data: PropTypes.shape({
    sms_messages: PropTypes.array.isRequired,
  }),
  getReferralsQuery: PropTypes.func.isRequired,
};

export default withRouter(connect(state => ({
  modalVisible: state.modal.visible,
}), {
  openModal,
  getReferralsQuery,
})(smsMessageSidebar));
